import React, { Component } from 'react'
import { sharedAppStateStore } from 'src/store/AppStateStore'

export class ErrorBoundry extends Component<React.PropsWithChildren> {
  componentDidCatch(error: Error) {
    sharedAppStateStore.handleError(error)
  }

  render() {
    return <>{this.props.children}</>
  }
}
